import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
import { nextIteration } from "./_nextIteration.js";
import { nextIterationWithIndex } from "./_nextIterationWithIndex.js";
export const selectMany = (source, selector) => {
    const generator = async () => {
        let values;
        if (typeof selector === "function") {
            if (selector.length === 1) {
                values = nextIteration(source, selector);
            }
            else {
                values = nextIterationWithIndex(source, selector);
            }
        }
        else {
            values = nextIteration(source, (x) => x[selector]);
        }
        const valuesArray = [];
        switch (values.type) {
            case 0: {
                for (const outer of await values.generator()) {
                    for (const y of outer) {
                        valuesArray.push(y);
                    }
                }
                break;
            }
            case 1: {
                for (const outer of values.generator()) {
                    for (const y of await outer) {
                        valuesArray.push(y);
                    }
                }
                break;
            }
            case 2: {
                for (const outer of await values.generator()) {
                    for (const y of await outer) {
                        valuesArray.push(y);
                    }
                }
                break;
            }
        }
        return valuesArray;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
